import type { RouteRecordRaw } from 'vue-router';

const routes: RouteRecordRaw[] = [
  // {
  //   component: BasicLayout,
  //   meta: {
  //     icon: 'mdi:shield-key-outline',
  //     order: 3,
  //     title: $t('page.dashboard.auth'),
  //     keepAlive: true,
  //     hideInMenu: true,
  //   },
  //   path: '/auth',
  //   name: 'AuthBase',
  //   children: [
  //     {
  //       name: 'Auth',
  //       path: 'authShop',
  //       component: () => import('#/views/auth/authShop/index.vue'),
  //       meta: {
  //         icon: 'mdi:shop',
  //         title: $t('page.dashboard.authShop'),
  //         keepAlive: true,
  //         hideInMenu: true,
  //       },
  //     },
  //   ],
  // },
];

export default routes;
